export {colors} from './colors'

export const DraggableTypes = {
  GIF: Symbol("GIF")
}

export const errors = {
  NO_SELECTION_ERROR: 'Oops, select something before submitting!'
}



// WEBPACK FOOTER //
// ./src/constants/index.js